import CssBaseline from '@material-ui/core/CssBaseline';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import Container from "react-modal-promise";
import { Router } from 'react-router-dom';
import RefreshListener from './components/RefreshListener';
import { CartProvider } from './contexts/cart';
import Routes from './routes';
import history from './services/history';

function App() {
  return (
    <React.Fragment>
      <CssBaseline />
      <SnackbarProvider autoHideDuration={3000} maxSnack={1}>
        <CartProvider>
          <Container />
          <RefreshListener />
          <Router history={history}>
            <Routes />
          </Router>
        </CartProvider>
      </SnackbarProvider>
    </React.Fragment>
  )
}

export default App;
